import React, { createContext, useContext } from 'react'

export const ApolloNPCContext = createContext()
export const useApolloNPCClient = () => useContext(ApolloNPCContext)

// Apollo Non Persistent Content Provider
export function ApolloNPCProvider({ client, children }) {
  return <ApolloNPCContext.Provider value={client}>{children}</ApolloNPCContext.Provider>
}
